import React from "react";

import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { OmnipodConstants } from "@/lib/drivers/insulet/OmnipodConstants.ts";
import { Button } from "@/uiKit/atoms/Button.tsx";

export type OmnipodSearchButtonProps = {
  className?: string;
};

export const OmnipodSearchButton: React.FC<OmnipodSearchButtonProps> = ({ className }) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  return (
    <Button
      variant="contained"
      className={cx(styles.container, className)}
      onClick={async () => {
        const device = await navigator.usb.requestDevice({
          filters: [OmnipodConstants.DASH_USB_IDS],
        });
        console.info(device);
      }}
    >
      {t("devices.omnipod.searchForDevice")}
    </Button>
  );
};

const makeStyles = () => ({
  container: css({}),
});
